import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';

class MMEVariableSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      selected: props.selectedOptions ? cloneDeep(props.selectedOptions) : [],
    };
  }

  componentDidMount() {
    this.didMount();
  }

  didMount = () => {
    const currentState = this.state.data;
    const { selectedOptions } = this.props;
    let newState = [];
    if (selectedOptions) {
      newState = currentState.map(items => {
        if (selectedOptions.includes(items.value)) {
          items.customClass = 'all-checked';
          items.checked = true;
        }
        if (items.childNode) {
          items.children.map(item => {
            if (selectedOptions.includes(item.value)) {
              item.checked = true;
            }
            return item;
          });
          if (items.children.every(item => item.checked)) {
            items.customClass = 'all-checked';
          } else if (items.children.some(item => item.checked)) {
            items.customClass = 'intermediate';
          } else {
            items.customClass = 'none-checked';
          }
        }
        return items;
      });
      this.setState({ data: newState });
    }
  }

  pushItems = (selected, value) => {
    const newList = selected;
    if (!newList.includes(value)) {
      newList.push(value);
      return newList;
    }
    return newList;
  }

  deleteItems = (selected, value) => {
    const newList = selected;
    if (newList.includes(value)) {
      newList.splice(newList.indexOf(value), 1);
      return newList;
    }
    return newList;
  }

  handleParentChange = e => {
    let newState = [];
    // eslint-disable-next-line react/no-access-state-in-setstate
    let selectedValues = this.state.selected;
    if (e.target.value) {
      const selectedId = e.target.id;
      const currentState = this.state.data;
      let checkedValue;
      newState = currentState.map(list => {
        if (list.id === selectedId) {
          if (e.target.className === 'intermediate') {
            checkedValue = true;
            list.checked = true;
            list.customClass = 'all-checked';
          } else if (e.target.className === 'all-checked') {
            checkedValue = false;
            list.checked = false;
            list.customClass = 'none-checked';
          } else {
            checkedValue = true;
            list.checked = true;
            list.customClass = 'all-checked';
          }
          if (list.childNode) {
            list.children.map(item => {
              item.checked = checkedValue;
              if (checkedValue) {
                selectedValues = this.pushItems(selectedValues, item.value);
              } else {
                selectedValues = this.deleteItems(selectedValues, item.value);
              }
              return item;
            });
          } else if (e.target.checked) {
            selectedValues = this.pushItems(selectedValues, e.target.value);
          } else {
            selectedValues = this.deleteItems(selectedValues, e.target.value);
          }
        }
        return list;
      });
    }
    this.setState({ data: newState, selected: selectedValues }, () => {
      this.props.updateSelectedAction(selectedValues);
    });
  }

  handleChildChange = e => {
    let newState = [];
    let selectedValues = this.state.selected;
    const selectedId = e.target.id;
    const currentState = this.state.data;
    if (e) {
      const parentId = e.target.value;
      newState = currentState.map(item => {
        if (item.id === parentId) {
          item.children.map(child => {
            if (child.id === selectedId) {
              child.checked = !child.checked;
              if (child.checked) {
                selectedValues = this.pushItems(selectedValues, e.target.dataset.value);
              } else {
                selectedValues = this.deleteItems(selectedValues, e.target.dataset.value);
              }
            }
            return child;
          });
          const allChecked = item.children.every(child => child.checked);
          const intermediateChecked = item.children.some(child => child.checked);
          if (allChecked) {
            item.customClass = 'all-checked';
          } else if (intermediateChecked) {
            item.customClass = 'intermediate';
          } else {
            item.customClass = 'none-checked';
          }
        }
        return item;
      });
      this.setState({ data: newState, selected: selectedValues }, () => {
        this.props.updateSelectedAction(selectedValues);
      });
    }
  }

  render() {
    const { data } = this.state;
    if (data.length > 0) {
      return (
        <div>
          {data.map(item =>
            (<div key={item.label} className="stmt-parent-check">
              <input
                id={item.id}
                className={item.customClass}
                type="checkbox"
                onChange={e => this.handleParentChange(e)}
                value={item.value}
                checked={item.checked} />
              <label className={`stmt-parent-check-label ${item.customClass}`} htmlFor={item.id}>
                <span>{item.label}</span>
              </label>
              {item.childNode && item.children.map(child => (
                <div key={child.id} className="stmt-child-check">
                  <input
                    id={child.id}
                    type="checkbox"
                    onChange={e => this.handleChildChange(e)}
                    data-value={child.value}
                    value={child.pId}
                    checked={child.checked} />
                  <label className="stmt-child-check-label" htmlFor={child.id}>
                    <span>{child.label}</span>
                  </label>
                </div>
              ))}
            </div>))
          }
        </div>
      );
    }
    return <div />;
  }
}

MMEVariableSelection.propTypes = {
  data: PropTypes.instanceOf(Array),
  selectedOptions: PropTypes.instanceOf(Array),
  updateSelectedAction: PropTypes.func,
};

export default MMEVariableSelection;
